/**
 * @generated SignedSource<<6f70b25df019b5b3fb3068c33b8922fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef$data = {
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly isAiEnabledInAdminHub?: boolean | null | undefined;
      readonly isVirtualAgentAvailable: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef";
};
export type virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef$key = {
  readonly " $data"?: virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "checkForAiEnabledFF"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "virtualAgentPageWrapper_servicedeskSettingsVirtualAgentCommon_featuresRef",
  "selections": [
    {
      "concreteType": "VirtualAgentQueryApi",
      "kind": "LinkedField",
      "name": "virtualAgent",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "VirtualAgentFeatures",
          "kind": "LinkedField",
          "name": "virtualAgentEntitlements",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isVirtualAgentAvailable"
            },
            {
              "condition": "checkForAiEnabledFF",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "isAiEnabledInAdminHub"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "42a97b5ffefcd9410d6b8acb3750ec82";

export default node;
